<template lang="pug">
.google-map(:id="mapName")
</template>

<script>
/* global google */
import _ from 'lodash';
import styles from '@/data/flat_pale_theme.json';

export default {
  name: 'google-map',
  computed: {
    latLon() {
      if (_.isEmpty(this.location.address.lat_lng)) return null;
      return new google.maps.LatLng(
        this.location.address.lat_lng[0],
        this.location.address.lat_lng[1],
      );
    },
    mapName() {
      return `${this.name}-${parseInt(new Date().getTime() / 1000)}-map`;
    },
  },
  data() {
    return {
      data: null,
      marker: null,
    };
  },
  methods: {
    addMarker() {
      this.marker = new google.maps.Marker({
        position: this.latLon,
        map: this.map,
        title: this.location.label,
      });
    },
    refreshMap() {
      this.addMarker();
      if (this.map !== null) {
        this.map.setCenter(this.latLon);
      }
    },
  },
  mounted() {
    if (window.google !== undefined && this.latLon !== null) {
      this.map = new google.maps.Map(document.getElementById(this.mapName), {
        zoom: 13,
        center: this.latLon,
        styles,
      });
      this.addMarker();
    }
  },
  props: {
    name: {
      type: String,
    },
    location: {
      type: Object,
    },
  },
  watch: {
    'location.id': 'refreshMap',
  },
};
</script>

<style lang="scss" scoped>
.google-map {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: gray;
}
</style>
